export default __webpack_public_path__ + "static/hf-3-d9611ad025245da45a887106a3de54c1.png";